/**
 * Check if the source is a YouTube URL
 * @param url The URL to check
 * @returns boolean indicating if the URL is from YouTube
 */
export const isYouTubeUrl = (url: string): boolean => {
  return url.includes('youtube.com') || url.includes('youtu.be');
};

/**
 * Convert YouTube URL to embed format
 * @param url YouTube URL to convert
 * @returns YouTube embed URL
 */
export const getYouTubeEmbedUrl = (url: string): string => {
  let videoId = '';
  
  if (url.includes('youtube.com/watch')) {
    // Extract video ID from youtube.com/watch URL
    const urlParams = new URLSearchParams(new URL(url).search);
    videoId = urlParams.get('v') || '';
  } else if (url.includes('youtu.be/')) {
    // Extract video ID from youtu.be URL
    videoId = url.split('youtu.be/')[1].split('?')[0];
  }
  
  return `https://www.youtube.com/embed/${videoId}`;
}; 